
import {Vue,Component,Prop} from 'vue-property-decorator'
declare var $: any;
@Component({
    name:"ChangeTheme"
})
export default class ChangeTheme extends Vue{
    @Prop({default: () => ([])}) themeList!:[]                   //颜色列表   
    changeThemeColor(theme:String){
        //把className theme1，theme2，theme3挂载在app.vue的<div id="app"></div>上       
        $("#app").attr("class",""); 
        $("#app").addClass('theme'+theme);
        localStorage.setItem('themeName','theme'+theme)
    }
}
